module.exports = __webpack_public_path__ + "img/Mux.366c2ae2.png";